<template>
  <div class="reports inside-banner mobile-top">
  
    <reports-tour v-if="$store.state.tour & !loading"  class="noprint"/>
   
    <section
      class="pixelsbg bs-shadow"
      style="padding: 20px; min-height: 370px"
    >
      <div>
        <div
          v-if="enteredmtd && !$store.getters.isSales"
          @click="closeCharts()"
          style="
            overflow: scroll;
            color: #fff !important;
            opacity: 1;
            cursor: pointer;
          "
        >
          <div
            @click="closeCharts()"
            class="close-chart"
            syle="color: #fff!important; opacity: 1; display: flex;"
          >
            <span class="material-icons"> cancel_presentation </span>
          </div>

          <bar-white-month-new
            :headerData="newHeaderData"
            :backLog="backLogTotal"
            chart-type="Month"
            :stats="this.enteredMTDData"
          />
        </div>

        <div
          v-if="enteredytd && !$store.getters.isSales"
          @click="closeCharts()"
          style="
            overflow: scroll;
            color: #fff !important;
            opacity: 1;
            cursor: pointer;
          "
        >
          <div
            @click="closeCharts()"
            class="close-chart"
            syle="color: #fff!important; opacity: 1; display: flex;"
          >
            <span class="material-icons"> cancel_presentation </span>
          </div>

          <bar-white-year-new
            :headerData="newHeaderData"
            :backLog="backLogTotal"
            chart-type="Year"
            :stats="this.enteredYTDData"
          />
        </div>

        <div
          v-if="shippedmtd && !$store.getters.isSales"
          @click="closeCharts()"
          style="
            overflow: scroll;
            color: #fff !important;
            opacity: 1;
            cursor: pointer;
          "
        >
          <div
            @click="closeCharts()"
            class="close-chart"
            syle="color: #fff!important; opacity: 1; display: flex;"
          >
            <span class="material-icons"> cancel_presentation </span>
          </div>
          <bar-white-month-shipped-new
            :headerData="newHeaderData"
            :backLog="backLogTotal"
            chart-type="Month"
            :stats="this.shippedMTDData"
          />
        </div>

        <div
          v-if="shippedytd && !$store.getters.isSales"
          @click="closeCharts()"
          style="
            overflow: scroll;
            color: #fff !important;
            opacity: 1;
            cursor: pointer;
          "
        >
          <div
            @click="closeCharts()"
            class="close-chart"
            syle="color: #fff!important; opacity: 1; display: flex;"
          >
            <span class="material-icons"> cancel_presentation </span>
          </div>
          <bar-white-year-shipped-new
            :headerData="newHeaderData"
            :backLog="backLogTotal"
            chart-type="Year"
            :stats="this.shippedYTDData"
          />
        </div>

        <div class="banner-content">
          <div class="mb10" style="margin-right: -10px">
            <div v-if="loading || !reports" class="header-bucket-wrap text-center">
              <div class="top-back">
                <h5 id="report-step-1" class="text-white text-center top-titles mb0">Backlog</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h2 style="color: rgba(255, 255, 255, 0.6)">Loading....</h2>
              </div>
            </div>

            <router-link
              v-else-if="!loading && reports"
              :to="{
                path: '/reportdetails',
                query: {
                  status: reports.backlog[0].state,
                  territory: reports.backlog[0].territory,
                  acid: reports.backlog[0].acid,
                },
              }"
              
              class="backlog-back"
            >
              <div class="header-bucket-wrap text-center">
                <div class="top-back">
                  <h5
                    class="text-white text-center top-titles mb0"
                    id="report-step-1"
                  >
                    Backlog
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h2 v-if="!loading && reports" class="text-white text-center">
                    {{ noCents(reports.backlog[0].sales) }}
                  </h2>
                </div>
              </div>
            </router-link>
          </div>

          <div class="row-4" style="margin-right: -10px">
            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading || !reports" class="top-back">
                <h5 id="report-step-2" class="text-white top-titles mb0">In Scheduling</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                v-else-if="!loading && reports"
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[3].state,
                    territory: reports.backlog[3].territory,
                    acid: reports.backlog[3].acid,
                  },
                }"
                class="top-back"
              >
                <div>
                  <h5 class="text-white top-titles mb0" id="report-step-2">
                    In Scheduling
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>

                  <h3 v-if="reports.backlog[3].sales == 0" class="text-white">
                    {{ formatPrice(0) }}
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[3].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading || !reports" class="top-back">
                <h5 id="report-step-3" class="text-white top-titles mb0">In Production</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                v-else-if="!loading && reports"
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[2].state,
                    territory: reports.backlog[2].territory,
                    acid: reports.backlog[2].acid,
                  },
                }"
                
                class="top-back"
              >
                <div>
                  <h5 class="text-white top-titles mb0" id="report-step-3">
                    In Production
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h3 v-if="reports.backlog[2].sales == 0" class="text-white">
                    {{ formatPrice(0) }}
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[2].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div v-if="loading || !reports" class="top-back">
                <h5 id="report-step-4" class="text-white top-titles mb0">In Shipping</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <h3 style="color: rgba(255, 255, 255, 0.6)">Loading....</h3>
              </div>

              <router-link
                v-else-if="!loading && reports"
                :to="{
                  path: '/reportdetails',
                  query: {
                    status: reports.backlog[4].state,
                    territory: reports.backlog[4].territory,
                    acid: reports.backlog[4].acid,
                  },
                }"
                
                class="top-back"
              >
                <div>
                  <h5 class="text-white top-titles mb0" id="report-step-4">
                    In Shipping
                  </h5>
                  <span class="material-icons"> keyboard_arrow_down </span>
                  <h3 v-if="reports.backlog[4].sales == 0" class="text-white">
                    {{ formatPrice(0) }}
                  </h3>
                  <h3 v-else class="text-white">
                    {{ noCents(reports.backlog[4].sales) }}
                  </h3>
                </div>
              </router-link>
            </div>
          </div>

          <div
            v-if="!$store.getters.isSales"
            class="row-4"
            style="margin-right: -10px"
          >
            <div class="header-bucket-wrap text-center mb10">
              <div
                v-if="!loading"
                class="top-back"
                @click="showChart('enteredmonth')"
              >
                <h5 class="text-white top-titles mb0">Entered MTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>

                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 7000 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g fill="rgba(255, 255, 255, 0.8)">
                        <path
                          d="M1975,5551 L3150,5551 C3204,5551 3249,5595 3249,5650 L3249,7469 C3249,7524 3204,7568 3150,7568 L1975,7568 C1920,7568 1876,7524 1876,7469 L1876,5650 C1876,5595 1920,5551 1975,5551 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M3850,3826 L5025,3826 C5080,3826 5125,3870 5125,3925 L5125,7469 C5125,7524 5080,7568 5025,7568 L3850,7568 C3796,7568 3751,7524 3751,7469 L3751,3925 C3751,3870 3796,3826 3850,3826 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5726,1421 L6901,1421 C6955,1421 7000,1465 7000,1520 L7000,7469 C7000,7524 6955,7568 6901,7568 L5726,7568 C5671,7568 5626,7524 5626,7469 L5626,1520 C5626,1465 5671,1421 5726,1421 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M687,3306 C925,3306 1118,3500 1118,3738 C1118,3763 1116,3788 1112,3812 L2250,4463 C2327,4392 2430,4349 2543,4349 C2622,4349 2696,4370 2760,4407 L4025,2788 C3875,2618 3883,2359 4044,2198 C4194,2048 4434,2029 4605,2156 L5836,689 C5781,617 5750,528 5750,431 C5750,193 5943,0 6181,0 C6419,0 6613,194 6613,431 C6613,670 6419,863 6181,863 C6112,863 6046,846 5988,817 L4735,2310 C4817,2476 4785,2677 4654,2808 C4532,2930 4346,2968 4187,2903 L2904,4545 C2949,4613 2974,4694 2974,4780 C2974,5018 2781,5212 2543,5212 C2305,5212 2111,5018 2111,4780 C2111,4727 2121,4676 2139,4629 L1033,3996 C951,4105 824,4169 687,4169 C449,4169 255,3976 255,3738 C255,3500 449,3306 687,3306 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M100,4603 L1274,4603 C1329,4603 1374,4648 1374,4703 L1374,7469 C1374,7524 1329,7568 1274,7568 L100,7568 C45,7568 0,7524 0,7469 L0,4703 C0,4648 45,4603 100,4603 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div v-else class="top-back">
                <h5 class="text-white top-titles mb0">Entered MTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 7000 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g fill="rgba(255, 255, 255, 0.2)">
                        <path
                          d="M1975,5551 L3150,5551 C3204,5551 3249,5595 3249,5650 L3249,7469 C3249,7524 3204,7568 3150,7568 L1975,7568 C1920,7568 1876,7524 1876,7469 L1876,5650 C1876,5595 1920,5551 1975,5551 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M3850,3826 L5025,3826 C5080,3826 5125,3870 5125,3925 L5125,7469 C5125,7524 5080,7568 5025,7568 L3850,7568 C3796,7568 3751,7524 3751,7469 L3751,3925 C3751,3870 3796,3826 3850,3826 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5726,1421 L6901,1421 C6955,1421 7000,1465 7000,1520 L7000,7469 C7000,7524 6955,7568 6901,7568 L5726,7568 C5671,7568 5626,7524 5626,7469 L5626,1520 C5626,1465 5671,1421 5726,1421 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M687,3306 C925,3306 1118,3500 1118,3738 C1118,3763 1116,3788 1112,3812 L2250,4463 C2327,4392 2430,4349 2543,4349 C2622,4349 2696,4370 2760,4407 L4025,2788 C3875,2618 3883,2359 4044,2198 C4194,2048 4434,2029 4605,2156 L5836,689 C5781,617 5750,528 5750,431 C5750,193 5943,0 6181,0 C6419,0 6613,194 6613,431 C6613,670 6419,863 6181,863 C6112,863 6046,846 5988,817 L4735,2310 C4817,2476 4785,2677 4654,2808 C4532,2930 4346,2968 4187,2903 L2904,4545 C2949,4613 2974,4694 2974,4780 C2974,5018 2781,5212 2543,5212 C2305,5212 2111,5018 2111,4780 C2111,4727 2121,4676 2139,4629 L1033,3996 C951,4105 824,4169 687,4169 C449,4169 255,3976 255,3738 C255,3500 449,3306 687,3306 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M100,4603 L1274,4603 C1329,4603 1374,4648 1374,4703 L1374,7469 C1374,7524 1329,7568 1274,7568 L100,7568 C45,7568 0,7524 0,7469 L0,4703 C0,4648 45,4603 100,4603 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div
                v-if="!loading"
                class="top-back"
                @click="showChart('enteredyear')"
              >
                <h5 class="text-white top-titles mb0">Entered YTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 6984 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="noun_bar-chart_3411029right2"
                        fill="rgba(255, 255, 255, 0.8)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4186.28522 L3134,4186.28522 C3188,4186.28522 3233,4230.28522 3233,4285.28522 L3233,7469 C3233,7524 3188,7568 3134,7568 L1959,7568 C1904,7568 1860,7524 1860,7469 L1860,4285.28522 C1860,4230.28522 1904,4186.28522 1959,4186.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,2907.12652 L1274,2907.12652 C1329,2907.12652 1374,2951.12652 1374,3006.12652 L1374,7469 C1374,7524 1329,7568 1274,7568 L99,7568 C45,7568 0,7524 0,7469 L0,3006.12652 C0,2951.12652 45,2907.12652 99,2907.12652 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,1892.90894 L6885,1892.90894 C6939,1892.90894 6984,1936.90894 6984,1991.90894 L6984,7469 C6984,7524 6939,7568 6885,7568 L5710,7568 C5655,7568 5610,7524 5610,7469 L5610,1991.90894 C5610,1936.90894 5655,1892.90894 5710,1892.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M4009,2788 C3859,2618 3867,2359 4028,2198 C4178,2048 4418,2029 4589,2156 L5820,689 C5765,617 5734,528 5734,431 C5734,193 5927,0 6165,0 C6403,0 6597,194 6597,431 C6597,670 6403,863 6165,863 C6096,863 6030,846 5972,817 L4719,2310 C4801,2476 4769,2677 4638,2808 C4516,2930 4330,2968 4171,2903 L4009,2788 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M708,1529 C946,1529 1139,1727 1139,1965 C1139,1990 1139.21125,2094.69309 1135.21125,2118.69309 C1131.21125,2142.69309 2121.90916,3005.95052 2267.87012,3129.06836 C2192.1084,3183.98828 2166.24805,3216.15039 2135.35254,3261.68066 C2066.30308,3189.92384 1931.34729,3063.18941 1021.91981,2270.64405 C939.919807,2379.64405 845,2396 708,2396 C470,2396 276,2203 276,1965 C276,1727 470,1529 708,1529 Z"
                          id="Path-Copy"
                        ></path>
                        <path
                          d="M2874.76727,2281.91661 C3112.76727,2281.91661 3305.76727,2479.91661 3305.76727,2717.91661 C3305.76727,2742.91661 3340.87383,2843.82919 3149.86992,3069.52778 C3153.92424,2988.39305 3625.85276,4020.64881 3695.65535,4153.08103 C3629.1616,4180.47309 3547.90963,4229.34179 3512.0125,4290.61922 C3484.46271,4221.60636 2990.15429,3159.90983 2993.22642,3169.10395 C2908.84883,3187.18938 2779.38503,3177.41932 2665.6269,3115.8904 C2551.86877,3054.36147 2442.76727,2955.91661 2442.76727,2717.91661 C2442.76727,2479.91661 2636.76727,2281.91661 2874.76727,2281.91661 Z"
                          id="Path-Copy-4"
                          transform="translate(3069.211310, 3286.267917) rotate(-91.000000) translate(-3069.211310, -3286.267917) "
                        ></path>
                        <path
                          d="M3802.56108,3714.49832 L4976.56108,3714.49832 C5031.56108,3714.49832 5076.56108,3759.49832 5076.56108,3814.49832 L5103,7469 C5103,7524 5058,7568 5003,7568 L3829,7568 C3774,7568 3729,7524 3729,7469 L3702.56108,3814.49832 C3702.56108,3759.49832 3747.56108,3714.49832 3802.56108,3714.49832 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div v-else class="top-back">
                <h5 class="text-white top-titles mb0">Entered YTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 6984 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="noun_bar-chart_3411029right2"
                        fill="rgba(255, 255, 255, 0.2)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4186.28522 L3134,4186.28522 C3188,4186.28522 3233,4230.28522 3233,4285.28522 L3233,7469 C3233,7524 3188,7568 3134,7568 L1959,7568 C1904,7568 1860,7524 1860,7469 L1860,4285.28522 C1860,4230.28522 1904,4186.28522 1959,4186.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,2907.12652 L1274,2907.12652 C1329,2907.12652 1374,2951.12652 1374,3006.12652 L1374,7469 C1374,7524 1329,7568 1274,7568 L99,7568 C45,7568 0,7524 0,7469 L0,3006.12652 C0,2951.12652 45,2907.12652 99,2907.12652 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,1892.90894 L6885,1892.90894 C6939,1892.90894 6984,1936.90894 6984,1991.90894 L6984,7469 C6984,7524 6939,7568 6885,7568 L5710,7568 C5655,7568 5610,7524 5610,7469 L5610,1991.90894 C5610,1936.90894 5655,1892.90894 5710,1892.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M4009,2788 C3859,2618 3867,2359 4028,2198 C4178,2048 4418,2029 4589,2156 L5820,689 C5765,617 5734,528 5734,431 C5734,193 5927,0 6165,0 C6403,0 6597,194 6597,431 C6597,670 6403,863 6165,863 C6096,863 6030,846 5972,817 L4719,2310 C4801,2476 4769,2677 4638,2808 C4516,2930 4330,2968 4171,2903 L4009,2788 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M708,1529 C946,1529 1139,1727 1139,1965 C1139,1990 1139.21125,2094.69309 1135.21125,2118.69309 C1131.21125,2142.69309 2121.90916,3005.95052 2267.87012,3129.06836 C2192.1084,3183.98828 2166.24805,3216.15039 2135.35254,3261.68066 C2066.30308,3189.92384 1931.34729,3063.18941 1021.91981,2270.64405 C939.919807,2379.64405 845,2396 708,2396 C470,2396 276,2203 276,1965 C276,1727 470,1529 708,1529 Z"
                          id="Path-Copy"
                        ></path>
                        <path
                          d="M2874.76727,2281.91661 C3112.76727,2281.91661 3305.76727,2479.91661 3305.76727,2717.91661 C3305.76727,2742.91661 3340.87383,2843.82919 3149.86992,3069.52778 C3153.92424,2988.39305 3625.85276,4020.64881 3695.65535,4153.08103 C3629.1616,4180.47309 3547.90963,4229.34179 3512.0125,4290.61922 C3484.46271,4221.60636 2990.15429,3159.90983 2993.22642,3169.10395 C2908.84883,3187.18938 2779.38503,3177.41932 2665.6269,3115.8904 C2551.86877,3054.36147 2442.76727,2955.91661 2442.76727,2717.91661 C2442.76727,2479.91661 2636.76727,2281.91661 2874.76727,2281.91661 Z"
                          id="Path-Copy-4"
                          transform="translate(3069.211310, 3286.267917) rotate(-91.000000) translate(-3069.211310, -3286.267917) "
                        ></path>
                        <path
                          d="M3802.56108,3714.49832 L4976.56108,3714.49832 C5031.56108,3714.49832 5076.56108,3759.49832 5076.56108,3814.49832 L5103,7469 C5103,7524 5058,7568 5003,7568 L3829,7568 C3774,7568 3729,7524 3729,7469 L3702.56108,3814.49832 C3702.56108,3759.49832 3747.56108,3714.49832 3802.56108,3714.49832 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div
                v-if="!loading"
                class="top-back"
                @click="showChart('shippedmonth')"
              >
                <h5 class="text-white top-titles mb0">Shipped MTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>

                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 7317 7695"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="noun_bar-chart_3411029right2"
                        fill="rgba(255, 255, 255, 0.8)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4313.28522 L3134,4313.28522 C3188,4313.28522 3233,4357.28522 3233,4412.28522 L3233,7596 C3233,7651 3188,7695 3134,7695 L1959,7695 C1904,7695 1860,7651 1860,7596 L1860,4412.28522 C1860,4357.28522 1904,4313.28522 1959,4313.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,3034.12652 L1274,3034.12652 C1329,3034.12652 1374,3078.12652 1374,3133.12652 L1374,7596 C1374,7651 1329,7695 1274,7695 L99,7695 C45,7695 0,7651 0,7596 L0,3133.12652 C0,3078.12652 45,3034.12652 99,3034.12652 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,2019.90894 L6885,2019.90894 C6939,2019.90894 6984,2063.90894 6984,2118.90894 L6984,7596 C6984,7651 6939,7695 6885,7695 L5710,7695 C5655,7695 5610,7651 5610,7596 L5610,2118.90894 C5610,2063.90894 5655,2019.90894 5710,2019.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5793,689 C5738,617 5707,528 5707,431 C5707,193 5900,0 6138,0 C6376,0 6570,194 6570,431 C6570,670 6376,863 6138,863 C6069,863 6003,846 5945,817 L5793,689 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M708,1656 C946,1656 1139,1854 1139,2092 C1139,2117 1139.21125,2221.69309 1135.21125,2245.69309 C1131.21125,2269.69309 2096.70311,3108.74153 2242.66406,3231.85937 C2166.63281,3291.00781 2166.77344,3313.88281 2124.98438,3379.23438 C2055.93492,3307.47755 1931.34729,3190.18941 1021.91981,2397.64405 C939.919807,2506.64405 845,2523 708,2523 C470,2523 276,2330 276,2092 C276,1854 470,1656 708,1656 Z"
                          id="Path-Copy"
                        ></path>
                        <path
                          d="M2807.75965,2914.16404 C3045.75965,2914.16404 3238.75965,3112.16404 3238.75965,3350.16404 C3238.75965,3375.16404 3273.86621,3476.07662 3082.8623,3701.77521 C3086.91662,3620.64048 3525.78439,4607.97423 3595.57886,4740.40644 C3529.09323,4767.7985 3455.35075,4800.10693 3413.38858,4861.15399 C3385.83879,4792.14314 2923.14667,3792.15726 2926.2188,3801.35138 C2841.84121,3819.43681 2712.37741,3809.66675 2598.61928,3748.13783 C2484.86115,3686.6089 2375.75965,3588.16404 2375.75965,3350.16404 C2375.75965,3112.16404 2569.75965,2914.16404 2807.75965,2914.16404 Z"
                          id="Path-Copy-4"
                          transform="translate(2985.669253, 3887.659012) rotate(-37.000000) translate(-2985.669253, -3887.659012) "
                        ></path>
                        <path
                          d="M4454.63568,817.849059 C4692.63568,817.849059 4885.63568,1015.84906 4885.63568,1253.84906 C4885.63568,1278.84906 4920.74224,1379.76164 4729.73833,1605.46023 C4733.79265,1524.3255 6087.00378,4739.89804 6156.79825,4872.33025 C6086.43485,4882.55925 6038.52438,4883.28157 5946.20842,4917.97969 C5918.65863,4848.96884 4570.0227,1695.84228 4573.09483,1705.0364 C4488.71724,1723.12183 4359.25344,1713.35177 4245.49531,1651.82285 C4131.73718,1590.29392 4022.63568,1491.84906 4022.63568,1253.84906 C4022.63568,1015.84906 4216.63568,817.849059 4454.63568,817.849059 Z"
                          id="Path-Copy-4-Copy"
                          transform="translate(5089.716968, 2867.914375) rotate(-133.000000) translate(-5089.716968, -2867.914375) "
                        ></path>
                        <path
                          d="M3802.56108,5256.9375 L4976.56108,5256.9375 C5031.56108,5256.9375 5076.56108,5301.9375 5076.56108,5356.9375 L5103,7596 C5103,7651 5058,7695 5003,7695 L3829,7695 C3774,7695 3729,7651 3729,7596 L3702.56108,5356.9375 C3702.56108,5301.9375 3747.56108,5256.9375 3802.56108,5256.9375 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div v-else class="top-back">
                <h5 class="text-white top-titles mb0">Shipped MTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 7317 7695"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="noun_bar-chart_3411029right2"
                        fill="rgba(255, 255, 255, 0.2)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4313.28522 L3134,4313.28522 C3188,4313.28522 3233,4357.28522 3233,4412.28522 L3233,7596 C3233,7651 3188,7695 3134,7695 L1959,7695 C1904,7695 1860,7651 1860,7596 L1860,4412.28522 C1860,4357.28522 1904,4313.28522 1959,4313.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,3034.12652 L1274,3034.12652 C1329,3034.12652 1374,3078.12652 1374,3133.12652 L1374,7596 C1374,7651 1329,7695 1274,7695 L99,7695 C45,7695 0,7651 0,7596 L0,3133.12652 C0,3078.12652 45,3034.12652 99,3034.12652 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,2019.90894 L6885,2019.90894 C6939,2019.90894 6984,2063.90894 6984,2118.90894 L6984,7596 C6984,7651 6939,7695 6885,7695 L5710,7695 C5655,7695 5610,7651 5610,7596 L5610,2118.90894 C5610,2063.90894 5655,2019.90894 5710,2019.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5793,689 C5738,617 5707,528 5707,431 C5707,193 5900,0 6138,0 C6376,0 6570,194 6570,431 C6570,670 6376,863 6138,863 C6069,863 6003,846 5945,817 L5793,689 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M708,1656 C946,1656 1139,1854 1139,2092 C1139,2117 1139.21125,2221.69309 1135.21125,2245.69309 C1131.21125,2269.69309 2096.70311,3108.74153 2242.66406,3231.85937 C2166.63281,3291.00781 2166.77344,3313.88281 2124.98438,3379.23438 C2055.93492,3307.47755 1931.34729,3190.18941 1021.91981,2397.64405 C939.919807,2506.64405 845,2523 708,2523 C470,2523 276,2330 276,2092 C276,1854 470,1656 708,1656 Z"
                          id="Path-Copy"
                        ></path>
                        <path
                          d="M2807.75965,2914.16404 C3045.75965,2914.16404 3238.75965,3112.16404 3238.75965,3350.16404 C3238.75965,3375.16404 3273.86621,3476.07662 3082.8623,3701.77521 C3086.91662,3620.64048 3525.78439,4607.97423 3595.57886,4740.40644 C3529.09323,4767.7985 3455.35075,4800.10693 3413.38858,4861.15399 C3385.83879,4792.14314 2923.14667,3792.15726 2926.2188,3801.35138 C2841.84121,3819.43681 2712.37741,3809.66675 2598.61928,3748.13783 C2484.86115,3686.6089 2375.75965,3588.16404 2375.75965,3350.16404 C2375.75965,3112.16404 2569.75965,2914.16404 2807.75965,2914.16404 Z"
                          id="Path-Copy-4"
                          transform="translate(2985.669253, 3887.659012) rotate(-37.000000) translate(-2985.669253, -3887.659012) "
                        ></path>
                        <path
                          d="M4454.63568,817.849059 C4692.63568,817.849059 4885.63568,1015.84906 4885.63568,1253.84906 C4885.63568,1278.84906 4920.74224,1379.76164 4729.73833,1605.46023 C4733.79265,1524.3255 6087.00378,4739.89804 6156.79825,4872.33025 C6086.43485,4882.55925 6038.52438,4883.28157 5946.20842,4917.97969 C5918.65863,4848.96884 4570.0227,1695.84228 4573.09483,1705.0364 C4488.71724,1723.12183 4359.25344,1713.35177 4245.49531,1651.82285 C4131.73718,1590.29392 4022.63568,1491.84906 4022.63568,1253.84906 C4022.63568,1015.84906 4216.63568,817.849059 4454.63568,817.849059 Z"
                          id="Path-Copy-4-Copy"
                          transform="translate(5089.716968, 2867.914375) rotate(-133.000000) translate(-5089.716968, -2867.914375) "
                        ></path>
                        <path
                          d="M3802.56108,5256.9375 L4976.56108,5256.9375 C5031.56108,5256.9375 5076.56108,5301.9375 5076.56108,5356.9375 L5103,7596 C5103,7651 5058,7695 5003,7695 L3829,7695 C3774,7695 3729,7651 3729,7596 L3702.56108,5356.9375 C3702.56108,5301.9375 3747.56108,5256.9375 3802.56108,5256.9375 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>

            <div class="header-bucket-wrap text-center mb10">
              <div
                v-if="!loading"
                class="top-back"
                @click="showChart('shippedyear')"
              >
                <h5 class="text-white top-titles mb0">Shipped YTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 6984 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="chart"
                        fill="rgba(255, 255, 255, 0.8)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4186.28522 L3134,4186.28522 C3188,4186.28522 3233,4230.28522 3233,4285.28522 L3233,7469 C3233,7524 3188,7568 3134,7568 L1959,7568 C1904,7568 1860,7524 1860,7469 L1860,4285.28522 C1860,4230.28522 1904,4186.28522 1959,4186.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,4788.3701 L1274,4788.3701 C1329,4788.3701 1374,4832.3701 1374,4887.3701 L1374,7469 C1374,7524 1329,7568 1274,7568 L99,7568 C45,7568 0,7524 0,7469 L0,4887.3701 C0,4832.3701 45,4788.3701 99,4788.3701 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,1892.90894 L6885,1892.90894 C6939,1892.90894 6984,1936.90894 6984,1991.90894 L6984,7469 C6984,7524 6939,7568 6885,7568 L5710,7568 C5655,7568 5610,7524 5610,7469 L5610,1991.90894 C5610,1936.90894 5655,1892.90894 5710,1892.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M4009,2788 C3859,2618 3867,2359 4028,2198 C4178,2048 4418,2029 4589,2156 L5820,689 C5765,617 5734,528 5734,431 C5734,193 5927,0 6165,0 C6403,0 6597,194 6597,431 C6597,670 6403,863 6165,863 C6096,863 6030,846 5972,817 L4719,2310 C4801,2476 4769,2677 4638,2808 C4516,2930 4330,2968 4171,2903 L4009,2788 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M755.818645,3232.23346 C993.818645,3232.23346 1186.81865,3430.23346 1186.81865,3668.23346 C1186.81865,3693.23346 1187.0299,3797.92656 1183.0299,3821.92656 C1179.0299,3845.92656 1882.29185,4439.15383 1974.22049,4506.15598 C1830.82452,4636.46598 1913.52367,4696.25698 1802.26161,4592.94338 C1774.96017,4567.59232 1530.78578,4361.23703 1069.73845,3973.87751 C987.738452,4082.87751 892.818645,4099.23346 755.818645,4099.23346 C517.818645,4099.23346 323.818645,3906.23346 323.818645,3668.23346 C323.818645,3430.23346 517.818645,3232.23346 755.818645,3232.23346 Z"
                          id="Path-Copy"
                          transform="translate(1149.019565, 3938.843062) rotate(-57.000000) translate(-1149.019565, -3938.843062) "
                        ></path>
                        <path
                          d="M2850.90322,2295.8923 C3088.90322,2295.8923 3281.90322,2493.8923 3281.90322,2731.8923 C3281.90322,2756.8923 3317.00977,2857.80488 3126.00586,3083.50348 C3130.06018,3002.36874 3599.79959,3997.658 3681.92147,4162.31043 C3566.18733,4211.38989 3583.85399,4203.33761 3511.64324,4267.16808 C3479.60882,4197.45098 2966.29023,3173.88552 2969.36236,3183.07964 C2884.98477,3201.16507 2755.52098,3191.39501 2641.76285,3129.86609 C2528.00472,3068.33716 2418.90322,2969.8923 2418.90322,2731.8923 C2418.90322,2493.8923 2612.90322,2295.8923 2850.90322,2295.8923 Z"
                          id="Path-Copy-4"
                          transform="translate(3050.412344, 3281.530187) rotate(-91.000000) translate(-3050.412344, -3281.530187) "
                        ></path>
                        <path
                          d="M3802.56108,3714.49832 L4976.56108,3714.49832 C5031.56108,3714.49832 5076.56108,3759.49832 5076.56108,3814.49832 L5103,7469 C5103,7524 5058,7568 5003,7568 L3829,7568 C3774,7568 3729,7524 3729,7469 L3702.56108,3814.49832 C3702.56108,3759.49832 3747.56108,3714.49832 3802.56108,3714.49832 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>

              <div v-else class="top-back">
                <h5 class="text-white top-titles mb0">Shipped YTD <br/>Sales %</h5>
                <span class="material-icons"> keyboard_arrow_down </span>
                <div>
                  <svg
                    style="max-width: 75px"
                    viewBox="0 0 6984 7568"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="chart"
                        fill="rgba(255, 255, 255, 0.2)"
                        fill-rule="nonzero"
                      >
                        <path
                          d="M1959,4186.28522 L3134,4186.28522 C3188,4186.28522 3233,4230.28522 3233,4285.28522 L3233,7469 C3233,7524 3188,7568 3134,7568 L1959,7568 C1904,7568 1860,7524 1860,7469 L1860,4285.28522 C1860,4230.28522 1904,4186.28522 1959,4186.28522 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M99,4788.3701 L1274,4788.3701 C1329,4788.3701 1374,4832.3701 1374,4887.3701 L1374,7469 C1374,7524 1329,7568 1274,7568 L99,7568 C45,7568 0,7524 0,7469 L0,4887.3701 C0,4832.3701 45,4788.3701 99,4788.3701 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M5710,1892.90894 L6885,1892.90894 C6939,1892.90894 6984,1936.90894 6984,1991.90894 L6984,7469 C6984,7524 6939,7568 6885,7568 L5710,7568 C5655,7568 5610,7524 5610,7469 L5610,1991.90894 C5610,1936.90894 5655,1892.90894 5710,1892.90894 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M4009,2788 C3859,2618 3867,2359 4028,2198 C4178,2048 4418,2029 4589,2156 L5820,689 C5765,617 5734,528 5734,431 C5734,193 5927,0 6165,0 C6403,0 6597,194 6597,431 C6597,670 6403,863 6165,863 C6096,863 6030,846 5972,817 L4719,2310 C4801,2476 4769,2677 4638,2808 C4516,2930 4330,2968 4171,2903 L4009,2788 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M755.818645,3232.23346 C993.818645,3232.23346 1186.81865,3430.23346 1186.81865,3668.23346 C1186.81865,3693.23346 1187.0299,3797.92656 1183.0299,3821.92656 C1179.0299,3845.92656 1882.29185,4439.15383 1974.22049,4506.15598 C1830.82452,4636.46598 1913.52367,4696.25698 1802.26161,4592.94338 C1774.96017,4567.59232 1530.78578,4361.23703 1069.73845,3973.87751 C987.738452,4082.87751 892.818645,4099.23346 755.818645,4099.23346 C517.818645,4099.23346 323.818645,3906.23346 323.818645,3668.23346 C323.818645,3430.23346 517.818645,3232.23346 755.818645,3232.23346 Z"
                          id="Path-Copy"
                          transform="translate(1149.019565, 3938.843062) rotate(-57.000000) translate(-1149.019565, -3938.843062) "
                        ></path>
                        <path
                          d="M2850.90322,2295.8923 C3088.90322,2295.8923 3281.90322,2493.8923 3281.90322,2731.8923 C3281.90322,2756.8923 3317.00977,2857.80488 3126.00586,3083.50348 C3130.06018,3002.36874 3599.79959,3997.658 3681.92147,4162.31043 C3566.18733,4211.38989 3583.85399,4203.33761 3511.64324,4267.16808 C3479.60882,4197.45098 2966.29023,3173.88552 2969.36236,3183.07964 C2884.98477,3201.16507 2755.52098,3191.39501 2641.76285,3129.86609 C2528.00472,3068.33716 2418.90322,2969.8923 2418.90322,2731.8923 C2418.90322,2493.8923 2612.90322,2295.8923 2850.90322,2295.8923 Z"
                          id="Path-Copy-4"
                          transform="translate(3050.412344, 3281.530187) rotate(-91.000000) translate(-3050.412344, -3281.530187) "
                        ></path>
                        <path
                          d="M3802.56108,3714.49832 L4976.56108,3714.49832 C5031.56108,3714.49832 5076.56108,3759.49832 5076.56108,3814.49832 L5103,7469 C5103,7524 5058,7568 5003,7568 L3829,7568 C3774,7568 3729,7524 3729,7469 L3702.56108,3814.49832 C3702.56108,3759.49832 3747.56108,3714.49832 3802.56108,3714.49832 Z"
                          id="Path"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="search-btns">
            <div class="left-side" id="report-step-5">
              <div class="ac-select select-ac" style="margin-right: 10px">
                <!--
                <select v-if="loading && acFilter !== null" disabled class="form-control" id="exampleFormControlSelect1" v-model="acFilter">
                  <option selected class="all-contractors">{{acFilter}}</option>
                </select>
-->
                <select
                  v-if="loading && acFilter == null"
                  disabled
                  class="form-control"
                  id="exampleFormControlSelect1"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                </select>

                <select
                  v-else
                  class="form-control"
                  id="exampleFormControlSelect1"
                  v-model="acFilter"
                  v-on:change="getTerritories()"
                  :disabled="loading"
                >
                  <option :value="null" selected class="all-contractors">
                    Area Contractor
                  </option>
                  <option
                    v-for="ac in acs"
                    @click="setACFilterName(ac.acName)"
                    :key="ac.acid"
                    :value="ac.acid"
                  >
                    {{ " " + ac.acName + " (" + ac.acid + ")" }}
                  </option>
                </select>
              </div>

              <div
                class="dates ac-select select-year"
                id="year"
                style="margin-bottom: 10px; margin-right: 10px"
              >
                <div class="year-select">
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="yearFilter"
                    v-on:change="getTerritories()"
                    :disabled="loading"
                  >
                    <option
                      v-for="(year, index) in yearRange"
                      :key="year"
                      :value="year"
                      v-bind:selected="index === 0 ? 'selected' : false"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- territorries -->

              <div
                v-if="
                  loading &&
                  this.territoryFilter != null &&
                  !this.territories.length
                "
                class="dates ac-select select-territory"
                id="dates"
                style="
                  margin-bottom: 10px;
                  margin-right: 10px;
                  flex-shrink: 0;
                  flex-grow: 1;
                "
              >
                <div class="year-select">
                  <select
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option selected class="all-contractors">
                      Loading Territories....
                    </option>
                  </select>
                </div>
              </div>

              <div
                v-else-if="loading && this.territoryFilter == null"
                class="dates ac-select select-territory"
                id="dates"
                style="
                  margin-bottom: 10px;
                  margin-right: 10px;
                  flex-shrink: 0;
                  flex-grow: 1;
                "
              >
                <div class="year-select">
                  <select
                    disabled
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option :value="null" selected class="all-contractors">
                      All Territories
                    </option>
                  </select>
                </div>
              </div>

              <div
                v-else
                v-on:change="setTerritory"
                class="dates ac-select select-territory"
                id="dates"
                style="
                  margin-bottom: 10px;
                  margin-right: 10px;
                  flex-shrink: 0;
                  flex-grow: 1;
                "
              >
                <div class="year-select">
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="territoryFilter"
                    :disabled="loading"
                  >
                    <option :value="null" class="all-contractors">
                      All Territories
                    </option>

                    <option
                      v-for="territory in territories"
                      :key="territory.territoryName"
                      :value="territory.webSafeTerritory"
                      :selected="
                        territory.webSafeTerritory === territoryFilter
                          ? true
                          : false
                      "
                    >
                      {{ territory.territoryName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <button v-if="loading == true" disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>

            <button
              v-else-if="
                yearFilter ||
                acFilter ||
                territoryFilter ||
                searchStarted == true
              "
              @click="clearSearch"
              class="clear"
            >
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            <button v-else disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>

            <button v-if="loading == true" disabled class="search">
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>

            <button
              v-else-if="
                yearFilter || acFilter || (territoryFilter && searchStarted)
              "
              @click.prevent="searchQuery"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
          </div>
        </div>

        <!--      
        <h6
          class="disclaimer text-white"
          style="margin-top: 0;"
          v-if="searchStarted == true && this.changed == false"
        >*You are searching via: {{ this.acFilter != null ? "Area Contractor (" + this.acFilter + ")" : ''  }} {{ this.yearFilter != null ? "Year: " + this.yearFilter : '' }} {{ this.territoryFilter != null ? "Territory: " + decodeURIComponent(this.territoryFilter) : ' in all territories' }}</h6>
        <h6
          class="disclaimer text-white"
          style="margin-top: 0;"
          v-else-if="this.changed == true"
        >*Search parameters changed, click search to view your data</h6>
        
        <h6
          class="disclaimer text-white"
          style="margin-top: 0;"
          v-else
        >*You are {{ loading ? "loading" : "viewing" }} all Area Contractor sales data for {{new Date().getFullYear()}}</h6>
 -->
      </div>
      <div class="d-flex noprint">
        <router-link
          v-if="this.acFilter != null && !$store.getters.isSales"
          :to="{
            name: 'SalesReps',
            query: {
              ac: this.acFilter,
              year: this.yearFilter,
              territory: this.territoryFilter,
            },
          }"
          class="mb0 lh1 mlauto list-btn dib d-flex center"
        >
          Sales Reps
          <i class="material-icons">keyboard_arrow_right</i>
        </router-link>

        <router-link
          v-else-if="!$store.getters.isSales"
          :to="{ name: 'SalesReps' }"
          class="mb0 lh1 mlauto list-btn dib d-flex center"
        >
          Sales Reps
          <i class="material-icons">keyboard_arrow_right</i>
        </router-link>
      </div>
    </section>

    <div class="">
      <div class="row">


        <div
          v-if="loading == true && !reports"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div
            class="flex-box-wrap"
            style="padding: 50px 0; position: relative"
          >
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
              <p>Please be patient while we look up your data.</p>
            </div>
          </div>
        </div> 

       

        <div v-else-if="loading == false && reports" class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <div class="report-card" style="padding: 20px !important">
            <div class="d-flex">
              <h2 class="mrauto">Entered</h2>
              <div
                v-if="!$store.getters.isSales"
                style="padding-bottom: 10px"
              ></div>
            </div>

            <div class="rfr table-responsive">
              <table
                class="table-striped table-bordered"
                style="text-align: right !important"
              >
                <thead>
                  <tr>
                    <th scope="col">Month</th>
                    <th scope="col">Totals</th>
                    <th scope="col">Agri.</th>
                    <th scope="col">Bus.</th>
                    <th scope="col">Edu./Lib.</th>
                    <th scope="col">Govt.</th>
                    <th scope="col">Health.</th>
                    <th scope="col">K-12</th>
                    <th scope="col">Mfg.</th>
                    <th scope="col">Military</th>
                    <th scope="col">Museum</th>
                    <th scope="col">Other</th>
                    <th scope="col">Pub. Safety</th>
                
                    
             
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>January</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(1)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>February</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(2)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>March</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(3)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>April</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(4)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>May</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(5)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>June</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(6)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>July</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(7)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>August</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(8)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>September</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(9)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>October</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(10)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>November</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(11)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>December</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(12)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Totals</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(13)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            inmonth: report.monthEntered,
                            inyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>

                  <tr v-if="!$store.getters.isSales" style="text-align: left">
                    Quotas
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>MTD Goal</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(15)"
                    >
                      {{ noCents(report.salesCredit) }}
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>MTD %</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(16)"
                    >
                      {{ report.salesCredit }}%
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>YTD Goal</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(17)"
                    >
                      {{ noCents(report.salesCredit) }}
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>YTD %</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in enteredMonth(18)"
                    >
                      {{ report.salesCredit }}%
                    </td>
                  </tr>

                  <!--
                  <tr>
                    <td>MTD %</td>
              
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in reports.quotas"
                    >{{ report.m_Percentage + "%"}}</td>
                  </tr>
                  -->
                </tbody>
              </table>
            </div>
          </div>

          <div class="report-card" style="padding: 20px !important">
            <h2 class="mrauto">Shipped</h2>
            <div class="rfr table-responsive">
              <table
                class="table-striped table-bordered"
                style="text-align: right !important"
              >
                <thead>
                  <tr>
                    <th scope="col">Month</th>
                    <th scope="col">Totals</th>
                    <th scope="col">Agri.</th>
                    <th scope="col">Bus.</th>
                    <th scope="col">Edu./Lib.</th>
                    <th scope="col">Govt.</th>
                    <th scope="col">Health.</th>
                    <th scope="col">K-12</th>
                    <th scope="col">Mfg.</th>
                    <th scope="col">Military</th>
                    <th scope="col">Museum</th>
                    <th scope="col">Other</th>
                    <th scope="col">Pub. Safety</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>January</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(1)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>February</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(2)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>March</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(3)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>April</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(4)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>May</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(5)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>June</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(6)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>July</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(7)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>August</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(8)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>September</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(9)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>October</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(10)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>November</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(11)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>December</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(12)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>Totals</td>
                    <!--
                    <td>{{ rowTotal(this.enteredJan) | currency}}</td>
                    -->
                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(13)"
                    >
                      <router-link
                        :to="{
                          path: '/reportdetails',
                          query: {
                            acid: report.acid,
                            territory: report.territory,
                            shippedmonth: report.monthEntered,
                            shippedyear: report.year,
                            marketcode: report.marketCode,
                          },
                        }"
                        >{{ noCents(report.salesCredit) }}</router-link
                      >
                    </td>
                  </tr>

                  <tr v-if="!$store.getters.isSales" style="text-align: left;">
                    Quotas
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>MTD Goal</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(15)"
                    >
                      {{ noCents(report.salesCredit) }}
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>MTD %</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(16)"
                    >
                      {{ report.salesCredit }}%
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>YTD Goal</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(17)"
                    >
                      {{ noCents(report.salesCredit) }}
                    </td>
                  </tr>
                  <tr v-if="!$store.getters.isSales">
                    <td>YTD %</td>

                    <td
                      v-bind:key="index"
                      v-for="(report, index) in shippedMonth(18)"
                    >
                      {{ report.salesCredit }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="report-card" style="padding: 10px 20px 20px !important">
            <h6 class="disclaimer mt10" v-if="loading != true">
              *Credits displayed on this page reflect SSC net materials only,
              they do not include Wood Designs or DLA credits.
            </h6>
          </div>
        </div>

<!--
        <div
          v-else-if="loading == false && !reports"
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div>
            <img src="@/assets/img/sad.svg" />
            <p>Sorry, nothing was found...</p>
          </div>
        </div>
      -->

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
import * as d3 from "d3";
import Arc from "../components/DataViz/Arc.vue";
import { formatCurrency } from '../utils/utils';
//import Bar from "../components/DataViz/BarBackLog";

import BarWhiteMonthNew from "../components/DataViz/BarWhiteMonthNew.vue";
import BarWhiteYearNew from "../components/DataViz/BarWhiteYearNew.vue";
import BarWhiteMonthShippedNew from "../components/DataViz/BarWhiteMonthShippedNew.vue";
import BarWhiteYearShippedNew from "../components/DataViz/BarWhiteYearShippedNew.vue";
import reportsTour from "../components/Tours/reportsTour.vue";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer thisisanexampleofunauthorized"
  },
};

export default {
  name: "ReportsNew",
  components: {
    AtomSpinner,
    // Avatar,
    Arc,
    BarWhiteMonthNew,
    BarWhiteYearNew,
    BarWhiteMonthShippedNew,
    BarWhiteYearShippedNew,
    reportsTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      //endPointSwitch: this.$store.getters.isSales ? "/reportbyind": "reports2",
      newHeaderData: [],
      backLogTotal: "",
      search: "",
      searchStarted: false,
      reports: null,
      storedReports: null,
      selectedCat: 0,
      loading: true,
      territoryLoading: false,
      countOfPage: 25,
      currPage: 1,
      noQuestionFound: false,
      territory: "",
      territoryFilter: this.$route.query.territory
        ? this.$route.query.territory
        : null,
      territories: [],
      userFirst: "",
      userLast: "",
      //ACsGlobal: this.$store.state.acList.acList,
      acs: null,
      acFilter: null,
      acFilterName: null,
      yearRange: [],
      yearFilter: this.$route.query.year
        ? this.$route.query.year
        : new Date().getFullYear(),
      searchString: "",
      changed: false,
      enteredmtd: false,
      enteredytd: false,
      shippedmtd: false,
      shippedytd: false,
      gettingData: "Loading",
      spacesaverToken: localStorage.getItem("SSCUSER"),

      //monthChartData: reports.quotas,
      /*
      monthData: [
        {
          height: "44",
          name: "Grand Totals",
          sales: "3,662,456"
        },
        {
          height: "0",
          name: "Agriculture",
          sales: "0"
        },
        {
          height: "59",
          name: "Business",
          sales: "723,410"
        },
        {
          height: "40",
          name: "Edu/Library",
          sales: "864,888"
        },
        {
          height: "8",
          name: "Military",
          sales: "604,074"
        },
        {
          height: "37",
          name: "Government",
          sales: "230,942"
        },
        {
          height: "48",
          name: "Healthcare",
          sales: "208,951"
        },    
        {
          height: "55",
          name: "Museum",
          sales: "311,584"
        },
         {
          height: "46",
          name: "Public Safety",
          sales: "718,607"
        },
        {
          height: "0",
          name: "Other",
          sales: "0"
        },     
      ],
      yearData: [
        {
          height: "46",
          name: "Grand Totals",
        },
        {
          height: "22",
          name: "Agriculture",
        },
        {
          height: "66",
          name: "Business",
        },
        {
          height: "49",
          name: "Edu/Library",
        },
        {
          height: "8",
          name: "Military",
        },
        {
          height: "39",
          name: "Government",
        },
        {
          height: "47",
          name: "Healthcare",
        },    
        {
          height: "58",
          name: "Museum",
        },
         {
          height: "41",
          name: "Public Safety",
        },
        {
          height: "0",
          name: "Other",
        },       
      ]
      */
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      this.setFirstLast();
      this.getTerritories();
      this.getYears(2010);
      this.acListSync();

      return axios.get(`${this.searchEndpointCompute}`, auth).then(
        (response) => {
          //console.log("got the data " + response);
          this.reports = response.data;
          if(this.reports.length){
            this.loading = false;
          }
        },
        (error) => {
          console.log(error);
          this.$router.push("/");
        }
      );
      /*
      return axios
        .get(`${this.searchEndpointCompute}`, auth)
        .then((response) => {
          console.log("got the data " + response);
          this.reports = response.data;
          this.loading = false;
        });
        */
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },

    noCents: function(amount){
      const formattedValue = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);

      return formattedValue;
    },

    acListSync: function () {
      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            this.acs = response.data;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
      }
    },

    /*
    reportSync: function() {
      this.loading = true;
      
			if (Object.keys(this.reportsGlobal).length === 0) {
        console.log("getting them");
				return axios
					.get(`${this.ordermanageapi}/reports`, auth)
					.then((response) => {
						//console.log(response);
						this.reports = response.data;
						this.loading = false;
						this.$store.commit("UPDATE_REPORTS", this.reports);
					});     
			} else {
        console.log("vuex has length");
				this.reports = this.$store.state.reports.reportList;
        this.loading = false;      
			}
    },
*/

    acListSync: function () {
      this.loading = true;

      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;
            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            */
            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;

            this.loading = false;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
        this.loading = false;
      }
    },

    showChart: function (chart) {
      this.closeCharts();
      window.scrollTo(0, 0);
      if (chart === "enteredmonth") {
        this.shippedmtd = false;
        this.shippedytd = false;
        this.enteredytd = false;
        this.enteredmtd = true;
      } else if (chart === "enteredyear") {
        this.shippedmtd = false;
        this.shippedytd = false;
        this.enteredmtd = false;
        this.enteredytd = true;
      } else if (chart === "shippedmonth") {
        this.shippedytd = false;
        this.enteredmtd = false;
        this.enteredytd = false;
        this.shippedmtd = true;
      } else if (chart === "shippedyear") {
        this.enteredmtd = false;
        this.enteredytd = false;
        this.shippedmtd = false;
        this.shippedytd = true;
      }
    },
    closeCharts: function () {
      window.scrollTo(0, 0);
      this.enteredmtd = false;
      this.enteredytd = false;
      this.shippedmtd = false;
      this.shippedytd = false;
    },

    formatter: function (str) {
      return str.replace("%20", " ").replace("%26", "&");
    },

    decodeHtmlEntity: function (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    },

    parseHtmlEntities: function (str) {
      return str.replace(/&#([0-9]{1,3});/gi, function (match, numStr) {
        var num = parseInt(numStr, 10); // read num as normal number
        return String.fromCharCode(num);
      });
    },

    getTerritories: function () {
      this.changed = true;
      this.territory = null;
      //this.territoryFilter = null;
      let tString;

      if (this.acFilter != null && this.yearFilter == null) {
        //hac ac no year
        tString = `${this.ordermanageapi}/territory?acid=${this.acFilter}`;
      } else if (this.acFilter != null && this.yearFilter != null) {
        // has both
        tString = `${this.ordermanageapi}/territory?acid=${this.acFilter}&year=${this.yearFilter}`;
      } else {
        tString = `${this.ordermanageapi}/territory?acid=${this.acFilter}`;
      }

      this.$forceUpdate();
      //console.log(`${tString}`);

      if (this.acFilter != null) {
        //console.log("getting territories");
        this.territoryLoading = true;

        return axios.get(`${tString}`, auth).then((response) => {
          //console.log(response);
          this.territories = response.data.territories;
          this.territoryLoading = false;
        });
      }
    },

    setTerritory: function () {
      this.$forceUpdate();
      //console.log("setting territory");

      if (
        this.territoryFilter !== null ||
        this.territoryFilter !== "Other" ||
        this.territoryFilter !== "All Territories"
      ) {
        this.territory = this.territoryFilter;
      } else {
        this.territory = "";
      }
    },

    searchQuery(event) {
      this.searchStarted = true;
      this.closeCharts();
      this.changed = false;
      history.pushState(
        {},
        "",
        `/reports?ac=${this.acFilter}&year=${this.yearFilter}&territory=${
          this.territoryFilter == null ? "all" : this.territoryFilter
        }`
      );

      /*
      if (this.searchStarted === true) {
        this.storedReports = this.reports;
      }
      */

      this.search = "";
      this.loading = true;
      this.searching = true;

      if (
        this.territoryFilter !== null ||
        this.territoryFilter !== "Other" ||
        this.territoryFilter !== "All Territories"
      ) {
        this.territory = this.territoryFilter;
      } else {
        this.territory = "";
      }

      this.searchString = `${this.acFilterName} ${this.yearFilter} ${this.territoryFilter}`;

      //console.log("hitting this " + `${this.searchEndpointCompute}`);

      return axios.get(this.searchEndpointCompute, auth).then((response) => {
        this.reports = response.data;
        //console.log(response);
        this.loading = false;
        this.searching = false;
        this.$forceUpdate();
      });
    },

    clearSearch() {
      this.closeCharts();
      this.loading = true;
      //this.acs = null;

      /*
      if (this.searchStarted == true) {
        this.reports = this.storedReports;
        this.searchStarted = false;
      }
      */

      //this.listings = this.storedListings;

      this.searchValue = "";
      this.searchRender = !this.searchRender;
      this.acFilterName = null;
      this.acFilter = null;
      this.yearFilter = new Date().getFullYear();
      this.territoryFilter = null;
      this.territories = [];
      this.searchString = "";
      this.changed = false;
      axios.get(`${this.searchEndpointCompute}`, auth).then((response) => {
        //console.log(response);
        this.reports = response.data;
        this.loading = false;
        this.searching = false;
        history.pushState({}, "", `/reports`);
        this.$forceUpdate();
      });

      //this.$forceUpdate();
      //Vue.set(this.listings, this.storedListings);
    },

    setFirstLast() {
      this.userFirst = this.firstName;
      this.userLast = this.lastName;
    },

    rowTotal: function (month) {
      let m = month;
      let total = m.reduce(function (prev, cur) {
        return prev + cur.salesCredit;
      }, 0);
      return total;
    },

    // Returns a new array of objects made up of full names.
    getYears: function (startYear) {
      let currentYear = new Date().getFullYear(),
        years = [];
      startYear = startYear || 1980;
      while (startYear <= currentYear) {
        years.push(startYear++);
      }
      let yearsDesc = years.reverse();
      this.yearRange = yearsDesc;
      //return yearsDesc;
    },

    setACFilterName: function (ac) {
      //v-on:change="getTerritories()"
      //getTerritories();
      this.acFilterName = ac;
      //console.log(ac);
    },

    enteredMonth: function (month) {
      return this.reports.enteredQuotas.filter(
        (report) => report.monthEntered === month
      );
    },

    shippedMonth: function (month) {
      return this.reports.shippedQuotas.filter(
        (report) => report.monthEntered === month
      );
    },
  },

  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },

    enteredMTDData() {
      //enteredQuotas
      let enteredMTD = this.reports.enteredQuotas.filter(function (el) {
        return el.monthEntered === 16;
      });

      return enteredMTD;
    },
    enteredYTDData() {
      //enteredQuotas
      let enteredYTD = this.reports.enteredQuotas.filter(function (el) {
        return el.monthEntered === 18;
      });

      return enteredYTD;
    },
    shippedMTDData() {
      //shippedQuotas
      let shippedMTD = this.reports.shippedQuotas.filter(function (el) {
        return el.monthEntered === 16;
      });

      return shippedMTD;
    },
    shippedYTDData() {
      //shippedQuotas
      let shippedYTD = this.reports.shippedQuotas.filter(function (el) {
        return el.monthEntered === 16;
      });

      return shippedYTD;
    },
    /*
    foundNoQuestion: function () {
      if (this.search.length > 1 && this.filteredQuestions.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },
    */

    calcACName() {
      if (this.acFilter !== null) {
        let acNum = this.acFilter;
        let selectedACName = this.acs.filter(function (ac) {
          return ac.acid == acNum;
        });

        this.acFilterName = selectedACName[0].acName;
        return selectedACName[0].acName;
        //return selectedACName;
        //this.acFilterName = selectedACName.acName;
      } else {
        return null;
      }
    },

    userToken() {
      return this.$store.state.token;
    },

    //this is a comment

    reformatBackLogHeaderData: function () {
      if (!this.loading) {
        const formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });

        // strip out the first
        let filtered = this.reports.backlog.filter(function (
          value,
          index,
          arr
        ) {
          return value.state != "Backlog";
        });
        //let newData = this.reports.backlog.shift();
        return filtered.map(function (i) {
          // create a new object to store full name.
          var newObj = {};
          newObj["sales"] = formatter.format(i.sales);
          newObj["number"] = i.sales;
          newObj["state"] = i.state;
          return newObj;
          //console.log(newData);
        });
      } else {
        return [];
      }
    },

    headerSync: function () {
      if (this.reformatBackLogHeaderData.length) {
        this.newHeaderData = this.reformatBackLogHeaderData;
      } else {
        return;
      }
    },

    backlogTotalSync: function () {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      if (this.reports.backlog[0].sales) {
        this.backLogTotal = formatter.format(this.reports.backlog[0].sales);
      } else {
        this.backLogTotal = "";
      }
    },

    //Grand
    enteredGrand: function () {
      //return this.reports.entered.filter((report) => report.Market === " Grand");
      return this.reports.entered.slice(120, 130);
    },
    shippedGrand: function () {
      //return this.reports.entered.filter((report) => report.Market === " Grand");
      return this.reports.shipped.slice(120, 130);
    },
    searchEndpointCompute: function () {
      if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter != null
      ) {
        // All three fix me
        return `${this.ordermanageapi}/reports2?year=${this.yearFilter}&acid=${this.acFilter}&territory=${this.territoryFilter}`;
      } else if (
        this.acFilter == null &&
        this.yearFilter != null &&
        this.territoryFilter != null
      ) {
        // no AC, only year and territory
        return `${this.ordermanageapi}/reports2?year=${this.yearFilter}&territory=${this.territoryFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter == null &&
        this.territoryFilter != null
      ) {
        // no year, only AC and territory
        return `${this.ordermanageapi}/reports2?acid=${this.acFilter}&territory=${this.territoryFilter}`;
      } else if (
        this.acFilter == null &&
        this.yearFilter != null &&
        this.territoryFilter == null
      ) {
        // no AC, no territory, only year
        return `${this.ordermanageapi}/reports2?year=${this.yearFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter == null &&
        this.territoryFilter == null
      ) {
        // only ac, no year, no territory
        return `${this.ordermanageapi}/reports2?acid=${this.acFilter}`;
      } else if (
        this.acFilter != null &&
        this.yearFilter != null &&
        this.territoryFilter == null
      ) {
        // both ac and year and no territory
        return `${this.ordermanageapi}/reports2?year=${this.yearFilter}&acid=${this.acFilter}`;
      } else {
        return `${this.ordermanageapi}/reports2`;
      }
    },
    acInput() {
      return parse(this.acFilter);
    },
    /*
    reportsGlobal() {
			return this.$store.state.reports.reportList;
		},
    */
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
    if (this.$route.query.ac) {
      let parameters = this.$route.query;
      //console.log(parameters.ac)
      this.acFilter = parameters.ac;
    } else {
      this.acFilter = null;
    }
  },
  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.report-card {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  overflow: scroll;
}
.fromfortbg {
  background-color: rgba(92, 109, 126, 0.9);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.2'%3E%3Cg fill='%23262626'%3E%3Cpolygon points='1600 800 1400 800 1600 0'/%3E%3Cpolygon points='800 800 1600 600 1600 800'/%3E%3C/g%3E%3Cg fill='%23262626'%3E%3Cpolygon points='0 0 200 0 0 800'/%3E%3Cpolygon points='800 0 0 200 0 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
  font-size: 13px !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.text-white {
  color: #fff;
}
.disclaimer {
  padding: 0;
  font-style: italic;
}
.search-btns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0;
  margin-bottom: 10px;
}
select.form-control[data-v-639340da]:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575 !important;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.all-contractors {
  color: #757575 !important;
}
.mrauto {
  margin-right: auto;
}
.search-btns {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}
.top-titles {
  font-weight: 400;
}
.top-back {
  display: inline-block;
  padding: 10px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 4px;
  transition: background 0.5s ease;
  text-decoration: none;
}
.top-back span {
  font-size: 16px;
}

.top-back:hover {
  background: hsla(0, 0%, 100%, 0.4);
  cursor: pointer;
}
.top-back:active {
  background: hsla(0, 0%, 100%, 0.4);
  cursor: pointer;
}
.backlog-back {
  text-decoration: none;
}
.f-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.h-100 {
  height: 100%;
}
.box-hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.row-4 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
}

/*
@media (max-width:767px) {
  .top-back {
    flex-basis: calc(50% - 12px);
  }
}

@media (max-width:560px) {
  .top-back {
    flex-basis: 100%;
  }
}
*/

.header-bucket-wrap {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding-right: 10px;
}
.mb10 {
  margin-bottom: 10px;
}

.left-side {
  display: flex;
  flex-grow: 1;
}

.ac-select {
  transition: width 1s ease-in-out;
}
@media only screen and (max-width: 991px) {
  .left-side {
    display: block;
  }
}

@media only screen and (min-width: 992px) {
  #year {
    width: 40px !important;
    overflow: hidden;
  }
  .select-ac {
    flex: 0 0 300px;
  }
  .select-year {
    flex: 0 0 100px;
  }
  .select-territory {
    flex: 0 0 100px;
  }
}

@media only screen and (min-width: 1165px) {
  #year {
    width: 40px !important;
    overflow: hidden;
  }
  .select-ac {
    flex: 0 0 400px;
  }
  .select-year {
    flex: 0 0 150px;
  }
  .select-territory {
    flex: 0 0 100px;
  }
}

.dropdown-menu {
  background-color: rgba(50, 50, 50, 0.8);
  color: #fff;
}
.dropdown-item:focus,
.dropdown-item:hover {
  color: #16181b;
  text-decoration: none;
  background-color: rgba(100, 100, 100, 0.6);
}
html {
  scroll-behavior: smooth;
}
.list-btn {
  padding: 5px 2px 5px 10px !important;
}

@media print {
  /* ckeditor5-page-break/theme/pagebreak.css */
  table{
    width: 100%;
    font-size: 10px!important;
  }

  table td{
    font-size: 10px!important;
  }
}
</style>
